export const fileTypes = {
  gif: 'gif',
  pdf: 'pdf',
  video: 'video',
  image: 'image'
}

export const IMAGE_FILE_EXTENSIONS = ['jpg', 'jpeg', 'png']
